module.exports = __webpack_public_path__ + "img/logo_finetika.900a2390.png";